<div class="input-group">
  <div *ngIf="prepend" class="input-group-prepend">
    <span class="input-group-text" [innerHTML]="prepend"></span>
  </div>
  <div class="icon icon-left">
    <ng-content select="[left]"></ng-content>
  </div>
  <div [ngClass]="append ? 'icon-right-append' : 'icon-right'" class="icon">
    <ng-content select="[right]"></ng-content>
  </div>
  <input
    name="seachText"
    autocomplete="off"
    [(ngModel)]="value"
    [disabled]="disabled"
    [type]="type"
    class="form-control input input-lg"
    [placeholder]="placeholder"
    (ngModelChange)="outputChange.emit(value)"
    (focus)="outputFocus.emit(value)"
    (blur)="outputBlur.emit(value)"
    (keyup.enter)="outputEnter.emit(value)"
    (click)="outputClick.emit(value)"
    [id]="'searchBar'"
  />
  <div *ngIf="append" class="input-group-append">
    <span class="input-group-text" [innerHTML]="append"></span>
  </div>
</div>
